import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { StoreLayout } from "@/components/storefront/StoreLayout";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Payment from "@/pages/Payment";
import TrackOrder from "@/pages/TrackOrder";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";

import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminShipping from "@/pages/admin/AdminShipping";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOffers from "@/pages/admin/AdminOffers";
import AdminDispatch from "@/pages/admin/AdminDispatch";
import PrintAddresses from "@/pages/admin/PrintAddresses";
import AdminSettings from "@/pages/admin/AdminSettings";

const Store = (C) => (
  <StoreLayout>
    <C />
  </StoreLayout>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <SettingsProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<StoreLayout><Home /></StoreLayout>} />
            <Route path="/shop" element={<StoreLayout><Shop /></StoreLayout>} />
            <Route path="/product/:id" element={<StoreLayout><ProductDetail /></StoreLayout>} />
            <Route path="/cart" element={<StoreLayout><Cart /></StoreLayout>} />
            <Route path="/checkout" element={<StoreLayout><Checkout /></StoreLayout>} />
            <Route path="/payment/:orderId" element={<StoreLayout><Payment /></StoreLayout>} />
            <Route path="/order-success" element={<StoreLayout><OrderSuccess /></StoreLayout>} />
            <Route path="/track-order" element={<StoreLayout><TrackOrder /></StoreLayout>} />
            <Route path="/about" element={<StoreLayout><About /></StoreLayout>} />
            <Route path="/contact" element={<StoreLayout><Contact /></StoreLayout>} />
            <Route path="/faq" element={<StoreLayout><FAQ /></StoreLayout>} />

            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin/products" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
            <Route path="/admin/orders" element={<ProtectedRoute><AdminOrders /></ProtectedRoute>} />
            <Route path="/admin/shipping" element={<ProtectedRoute><AdminShipping /></ProtectedRoute>} />
            <Route path="/admin/categories" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
            <Route path="/admin/offers" element={<ProtectedRoute><AdminOffers /></ProtectedRoute>} />
            <Route path="/admin/dispatch" element={<ProtectedRoute><AdminDispatch /></ProtectedRoute>} />
            <Route path="/admin/dispatch/print" element={<ProtectedRoute><PrintAddresses /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </SettingsProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
